import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-clever',
    components: {
    },
})

export default class SSOClever extends Vue {
    @Prop()
    private ssoDetails: any;

    private ssoFields: any = {
        clientID: {
            name: 'Client ID',
            field: 'b-form-input',
            modelKey: 'clientID',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        clientSecret: {
            name: 'Client Secret',
            field: 'b-form-input',
            modelKey: 'clientSecret',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
    };
}
